import React from "react";
import { useFormikContext } from "formik";
import TextField from "@mui/material/TextField";

 import getTotalReceivingUnitsLabel from "../TotalReceivingUnits/getTotalReceivingUnitsLabel";

export default function UnitsFormInput({ name, value, label, onClick }) {
  const { errors, submitCount, getFieldMeta } = useFormikContext();
  const meta = getFieldMeta(name);
  const errorMessage = meta.error || errors[name];
  const error = (meta.touched || submitCount > 0) && errorMessage;

  return (
    <TextField
      fullWidth
      error={!!error}
      helperText={error}
      size="small"
      label={label}
      value={getTotalReceivingUnitsLabel(Array.isArray(value) ? value : [])}
      onClick={onClick}
    />
  );
}
